/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest interface.
 */
export function instanceOfFxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest(value) {
    if (!('Game' in value) || value['Game'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequestFromJSON(json) {
    return FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Game': json['Game'],
    };
}
export function FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequestToJSON(json) {
    return FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Game': value['Game'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest.js.map